import { render, staticRenderFns } from "./gallery-image.vue?vue&type=template&id=ed47cbda&"
import script from "./gallery-image.vue?vue&type=script&lang=ts&"
export * from "./gallery-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports